import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df5afd7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "tifh" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Request GET: ")
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Powered by", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "TIGTBIFHIMVA", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _hoisted_2,
      _createElementVNode("a", { href: _ctx.request_url }, "\"" + _toDisplayString(_ctx.request_url) + "\"", 9, _hoisted_3)
    ]),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.message), 1),
          (_ctx.time)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.time), 1))
            : _createCommentVNode("", true),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
  ]))
}